import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './tooltip.module.scss';

const Tooltip = ({ message, children, ...rest }) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <div className={styles.tooltip}>
      <div className={cx(styles['tooltip-box'], isVisible && styles.visible)}>
        {message}
        <span className="tooltip-arrow" />
      </div>
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        {...rest}
      >
        {children}
      </div>
    </div>
  );
};

Tooltip.defaultProps = {
  message: '',
  children: null,
};

Tooltip.defaultProps = {
  message: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default Tooltip;
